// extracted by mini-css-extract-plugin
module.exports = {"header":"BaseHeader_header__tMFbU","sticky":"BaseHeader_sticky__2X0fp","contextMenu":"BaseHeader_contextMenu__ZZGlR"};